import { Box } from '@mui/material';
import { useParams } from 'react-router-dom';
import { LwButton, Page, Toolbox } from 'redesign';
import { getWorkerFullName } from 'shared/utils/worker';
import { RenderUnsettledUI } from 'shared/components';
import { useCompanyRelativePath } from 'ogp/hooks';
import { routes } from 'ogp/Routes';
import { useTranslation } from 'react-i18next';
import { PartnerWorkerDetailTabs } from './partner-worker-detail-tabs';
import { EmployeeDetailHeader } from '../employee-detail/employee-detail-header';
import { useGetPartnerWorkerProfile } from '../../hooks/use-get-partner-worker-profile';
import { useWorkforceListParams } from '../../hooks/use-workforce-list-params';

export const PartnerWorkerDetail = () => {
  const { id } = useParams<'id'>();
  const workerQuery = useGetPartnerWorkerProfile(id ?? '');
  const generatePath = useCompanyRelativePath();
  const { queryParams } = useWorkforceListParams();
  const { t } = useTranslation('web-common');

  if (workerQuery.status !== 'success') {
    return <RenderUnsettledUI data={workerQuery} />;
  }

  const workerName = getWorkerFullName({
    firstName: workerQuery.data.firstName,
    infix: workerQuery.data.infix,
    lastName: workerQuery.data.lastName,
  });

  return (
    <Page
      header={
        <EmployeeDetailHeader
          name={workerName}
          profilePictureUrl={workerQuery.data.imageUrl}
          isOnboarded={true}
          labourEngagementState={null}
        />
      }
      toolbox={
        <Toolbox>
          <LwButton
            to={generatePath(routes.Workforce, undefined, queryParams)}
            type="submit"
            color="secondary"
          >
            {t('buttons.back', { ns: 'web-common' })}
          </LwButton>
        </Toolbox>
      }
    >
      <Box width="100%">
        <PartnerWorkerDetailTabs data={workerQuery.data} />
      </Box>
    </Page>
  );
};
